import { useMemo } from 'react';
import { Typography } from 'antd';
import { format } from 'date-fns';
import { Franchise } from '@/types';
import { AvatarPlaceholder } from '@/components/shared/avatar-placeholder';

interface Props {
  franchise: Franchise;
}

export default function BookingFranchiseDetailed({ franchise }: Props) {
  if (!franchise) return null;

  const { statusLabel, statusColor } = useMemo(() => {
    if (franchise.stripeSubscriptionStatus === 'trialing') {
      return { statusLabel: 'Trialing', statusColor: '#FFA500' };
    }
    if (franchise.stripeSubscriptionStatus === 'active') {
      return { statusLabel: 'active', statusColor: '#1C8271' };
    }
    if (franchise.stripeSubscriptionStatus === 'canceled') {
      return { statusLabel: 'Canceled', statusColor: '#F68B8B' };
    }
    return { statusLabel: '-', statusColor: '#gray' };
  }, [franchise]);

  return (
    <div className="detailed-wrapper" style={{ flex: 1 }}>
      <div className="detailed-content">
        {franchise.logo ? (
          <div className="cronofy-modal-img-wrap">
            <img
              src={franchise.logo}
              alt="Logo"
              className="cronofy-modal-img"
            />
          </div>
        ) : (
          <div
            style={{
              overflow: 'hidden',
              height: 140,
              width: 140,
              borderRadius: 16,
              fontSize: 36,
            }}
          >
            <AvatarPlaceholder
              firstName={franchise?.company || ''}
              lastName={''}
            />
          </div>
        )}

        <div className="details-section-column">
          <InfoLine label="Franchise" value={`${franchise.company}`} />
          <div className="details-section-line">
            <Typography.Text className="general-info-text">
              Status
            </Typography.Text>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  backgroundColor: franchise.isActivated
                    ? '#1C8271'
                    : '#F68B8B',
                }}
              />
              <Typography.Text>
                {franchise.isActivated ? 'Activated' : 'Inactive'}
              </Typography.Text>
            </div>
          </div>
          <div className="details-section-line">
            <Typography.Text className="general-info-text">
              Subscription
            </Typography.Text>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  backgroundColor: statusColor,
                }}
              />
              <Typography.Text>{statusLabel}</Typography.Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function InfoLine({ label, value }: { label: string; value: string }) {
  return (
    <div className="details-section-line">
      <Typography.Text className="general-info-text">{label}</Typography.Text>
      <Typography.Text className="general-info-value">{value}</Typography.Text>
    </div>
  );
}
